import CampaignCardGrid from './CampaignCardGrid';

export default CampaignCardGrid;
export type { CampaignTypeConfig } from './CampaignCardGrid';